import React        from 'react'
import Axios        from 'axios'
import PropTypes    from 'prop-types';
import NumberFormat from 'react-number-format'
import Swal         from 'sweetalert2'
//import './assets/sweetAlert.scss'

//export const hostUrl = window.location.host 
//export const hostUrl = "cobalsupermercado.com.br"
//export const hostUrl = "tcb.bomdapeste.com"
export const hostUrl = "papirodesign.com.br"

export const cmsHost = "https://www."+hostUrl+"/cms" 
//export const cmsHost = "https://cms.bomdapeste.com" 
//export const cmsHost = "http://"+hostUrl+"/cms" 

export const modules = [
  {nome:"painel", rotulo:"Painel"},
  {nome:"pedidos", rotulo:"Pedidos"},
  {nome:"produtos", rotulo:"Produtos"},
  {nome:"clientes", rotulo:"Clientes"},
  {nome:"usuarios", rotulo:"Usuários"},
  {nome:"config", rotulo:"Configurações"}
];

export const menuLateral = {
  painel:{
   desc:"Painel Inicial",
   icon:"fas fa-info-circle",
   link:"/adm/painel-inicial",
   items:[]
  },
  pedidos:{ 
     desc:"Pedidos",
     icon:"fas fa-shipping-fast",
     link:"/adm/pedidos",
     items:[]
    },
  produtos: {
      desc:"Produtos",
      icon:"fas fa-boxes",
      items:[
         {desc: "Listagem",      link: "/adm/listar-produtos",             icon:"fas fa-bars"},
         {desc: "Inserção",      link: "/adm/inserir-produto",             icon:"fas fa-plus"},
         {desc: "Seções",        link: "/adm/listar-secoes",               icon:"fas fa-tags"},
      ]
     },
  clientes:{
     desc:"Clientes",
     icon:"fas fa-users",
     link:"/adm/listar-clientes",
     items:[]
    },
  usuarios:{
     desc:"Usuários",
     icon:"fas fa-id-badge",
     link:"/adm/usuarios",
     items:[]
    },
  config: {
   desc:"Configurações",
   icon:"fas fa-cogs",
   items:[
      {desc: "Dados da Empresa",      link: "/adm/dados-empresa",             icon:"fas fa-warehouse"},
      {desc: "Infomações da Página",  link: "/adm/info-pagina",               icon:"fas fa-file-alt"},
      {desc: "Cabeçalho e Rodapé",    link: "/adm/cabecalho-rodape",          icon:"fas fa-newspaper"},
      {desc: "Primeira Página",       link: "/adm/banners-primeira-pagina",   icon:"fas fa-image"},
      {desc: "Imagens do Site",       link: "/adm/imagens-site",              icon:"far fa-images"},
   ]
  }
}

export const statusOptions = [{label:"Solicitado"}, {label:"Confirmado"}, {label:"Em Separação"}, {label:"Separado"}, {label:"Conferido"}, {label:"Embalado"}, {label:"Aguardando Retirada"}, {label:"Saiu para entrega"}, {label:"Recebido"}, {label:"Cancelado"}]

export const statusProduct = [{label:"Disponível"}, {label:"Indisponível"}]

export const binario = [{label:"Sim", value:true}, {label:"Não", value:false}]

export const statusTickets = [{label:"Reserva"}, {label:"Pago"}, {label:"Estorno"}, {label:"Cancelada"}]

export const mesesAbrev = ["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"]

export const diasSemana = ["domingo","segunda","terça","quarta","quinta","sexta","sábado"]

export const marcacoes = [
  {codigo: 1, icone: "fas fa-utensils", categoria: 'MERCEARIA', sub: [], destaque: true},
  {codigo: 2, icone: "fas fa-utensils", categoria: 'MERCEARIA SECA', sub: ['CEREAIS', 'AÇÚCAR', 'FARINÁCEOS', 'SAL', 'CESTA BÁSICA'], destaque: false},
  {codigo: 3, icone: "fas fa-utensils", categoria: 'MERCEARIA SALGADA', sub: ['MASSAS', 'ENLATADOS', 'CONSERVAS', 'TEMPEROS'], destaque: false},
  {codigo: 4, icone: "fas fa-utensils", categoria: 'MERCEARIA DOCE', sub: ['BOMBONIERE', 'SOBREMESAS', 'MATINAIS', 'ALIMENTO INFANTIL', 'CULINÁRIA DOCE', 'DOCES', 'DIET E LIGHT', 'BISCOITOS DOCES', 'BISCOITOS SALGADOS', 'SALGADINHOS'], destaque: false},
  {codigo: 5, icone: "fas fa-drumstick-bite", categoria: 'PERECÍVEIS', sub: ['PADARIA PRODUÇÃO PROPRIA', 'PADARIA PRODUTOS TERCEIROS', 'LANCHONETE', 'AÇOUGUE', 'PEIXARIA', 'RESTAURANTE', 'FRIAMBRERIA', 'LATICÍNEOS', 'CONGELADOS', 'EMPÓRIO A GRANEL'], destaque: true},
  {codigo: 6, icone: "fas fa-apple-alt", categoria: 'HORTIFRUTI', sub: ['HORTIFRUTIGRAJEIRO'], destaque: true},
  {codigo: 7, icone: "fas fa-wine-bottle", categoria: 'BEBIDAS', sub: ['DESTILADAS', 'VINHOS', 'CERVEJAS', 'NÃO ALCOÓLICOS', 'REFRIGERANTES'], destaque: true},
  {codigo: 8, icone: "fas fa-vial", categoria: 'PERFUMARIA', sub: ['ABSORVENTES', 'HIGIENE CORPORAL', 'HIGIENE BEBÊ', 'SHAMPOO', 'DESODORANTES', 'SABONETES', 'HIGIENE BUCAL', 'FARMÁCIA'], destaque: true},
  {codigo: 9, icone: "fas fa-flask", categoria: 'COSMÉTICOS', sub: ['BRONZEADORES', 'HIDRATANTES', 'COLONIAS', 'PRODUTOS CAPILARES', 'PRODUTO MANICURE', 'BARBEARIA'], destaque: true},
  {codigo:10, icone: "fas fa-broom", categoria: 'LIMPEZA', sub: ['LIMPEZA DE PISOS', 'LIMPEZA DE BANHEIROS', 'LIMPEZA DE COZINHA', 'ESPONJAS', 'LIMPEZA DE CASA', 'LAVANDERIA DE ROUPAS', 'INSETICIDAS', 'POLIDORES', 'CERAS PARA CALÇADOS'], destaque: true},
  {codigo:11, icone: "fas fa-store", categoria: 'BAZAR GERAL', sub: ['PRODUTOS AUTOMOTIVOS', 'FERRAMENTARIA', 'LINHA INOX', 'ALUMÍNIOS', 'UTILIDADES COZINHAS', 'ACESSORIOS PARA CAFÉ', 'VIDROS CRISTAIS E PORCELANAS', 'PLÁSTICOS', 'DESCARTÁVEIS', 'FESTAS', 'ENCARTELADOS', 'LIMPEZA CASEIRA', 'PAPELARIA', 'CAMPING E PESCA', 'BRINQUEDOS', 'HORTA E JARDIM', 'PRODUTOS PARA ANIMAIS', 'TABACARIA', 'MATERIAL ESPORTIVO', 'ARTIGOS DE CASA'], destaque: true},
  {codigo:12, icone: "fas fa-tshirt", categoria: 'TÉXTIL', sub: ['CALÇADOS', 'ROUPAS', 'CAMA, MESA E BANHO'], destaque: true},
  {codigo:13, icone: "fas fa-mitten", categoria: 'PADARIA', sub: ['PRODUÇÃO PRÓPRIA', 'INDUSTRIALIZADOS'], destaque: true}
];

export const banksList = [
  {code:1, name: "Banco do Brasil", data:"Titular: Fulano de Tal\nCPF: 287.916.304-88\nAgência: 5749-x\nConta: 32190\nTipo: Conta Corrente", src: "/imgs/nerifas/bancos/bb.jpg"},
  {code:237, name: "Bradesco", data:"Titular: Fulano de Tal\nCPF: 287.916.304-88\nAgência: 6749-x\nConta: 42190\nTipo: Conta Corrente", src: "/imgs/nerifas/bancos/bradesco.jpg"},
  {code:104, name: "Caixa Economica", data:"Titular: Fulano de Tal\nCPF: 287.916.304-88\nAgência: 7749-x\nConta: 52190\nOperação: 001\nTipo: Conta Corrente", src: "/imgs/nerifas/bancos/caixa.jpg"},
  {code:34, name: "Itaú", data:"Titular: Fulano de Tal\nCPF: 287.916.304-88\nAgência: 8749-x\nConta: 62190\nTipo: Conta Corrente", src: "/imgs/nerifas/bancos/itau.jpg"},
  {code:26, name: "PicPay", data:"Titular: @fulanodetal", src: "/imgs/nerifas/bancos/picpay.jpg"},
  {code:33, name: "Santander", data:"Titular: Fulano de Tal\nCPF: 287.916.304-88\nAgência: 9749-x\nConta: 72190\nTipo: Conta Corrente", src: "/imgs/nerifas/bancos/santander.jpg"},
]

export function corrigeAcentos(s){//retorna os acentos substituídos na codificação da URL
  var c=[["%C3%80","À"],["%C3%81","Á"],["%C3%82","Â"],["%C3%83","Ã"],["%C3%84","Ä"],["%C3%85","Å"],["%C3%86","Æ"],["%C3%87","Ç"],["%C3%88","È"],["%C3%89","É"],["%C3%8A","Ê"],["%C3%8B","Ë"],["%C3%8C","Ì"],["%C3%8D","Í"],["%C3%8E","Î"],["%C3%8F","Ï"],["%C3%90","Ð"],["%C3%91","Ñ"],["%C3%92","Ò"],["%C3%93","Ó"],["%C3%94","Ô"],["%C3%95","Õ"],["%C3%96","Ö"],["%C3%98","Ø"],["%C3%99","Ù"],["%C3%9A","Ú"],["%C3%9B","Û"],["%C3%9C","Ü"],["%C3%9D","Ý"],["%C3%9E","Þ"],["%C3%9F","ß"],["%C3%A0","à"],["%C3%A1","á"],["%C3%A2","â"],["%C3%A3","ã"],["%C3%A4","ä"],["%C3%A5","å"],["%C3%A6","æ"],["%C3%A7","ç"],["%C3%A8","è"],["%C3%A9","é"],["%C3%AA","ê"],["%C3%AB","ë"],["%C3%AC","ì"],["%C3%AD","í"],["%C3%AE","î"],["%C3%AF","ï"],["%C3%B0","ð"],["%C3%B1","ñ"],["%C3%B2","ò"],["%C3%B3","ó"],["%C3%B4","ô"],["%C3%B5","õ"],["%C3%B6","ö"],["%C3%B8","ø"],["%C3%B9","ù"],["%C3%BA","ú"],["%C3%BB","û"],["%C3%BC","ü"],["%C3%BD","ý"],["%C3%BE","þ"],["%C3%BF","ÿ"],["%C5%92","Œ"],["%C5%93","œ"],["%C5%A0","Š"],["%C5%A1","š"],["%C5%B8","Ÿ"],["%C6%92","ƒ"],["%20"," "]]
	c.forEach(v=>{s=s.replace(new RegExp(v[0],"gi"),v[1])})
	return s;
}

export function firstUpperCase(txt){ txt=txt.trim(); return txt.length ? txt.substr(0,1).toUpperCase() + txt.toLowerCase().substr(1, txt.length) : "" }

export function acentoPorPonto(s){let sa="áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ",n="";for (var i = 0; i < s.length; i++){if(sa.indexOf(s.charAt(i))!==-1){n+="."}else{n+=s.substr(i, 1)}}return n}

export function semAcentos(s){let sa="áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ",ss="aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC",n="";for (var i = 0; i < s.length; i++){if(sa.indexOf(s.charAt(i))!==-1){n+=ss.substr(sa.search(s.substr(i,1)),1)}else{n+=s.substr(i, 1)}}return n}

export function hoursFromNow(objectId){
  let now = new Date(), horas=0, min=0,
     data = new Date(parseInt(objectId.substring(0, 8), 16) * 1000);

  now = (new Date(now.getTime() - data.getTime())).getTime()
  horas = Math.floor(now/3600000)
  min = Math.floor((now - horas*3600000)/60000)
	return horas+":"+("0"+min).substr(-2);
}

export function dateFromObjectId(objectId){
	return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
}

export function hoursFromDate(objectId, DateTimer){
  let now = new Date(DateTimer), horas=0, min=0,
     data = new Date(parseInt(objectId.substring(0, 8), 16) * 1000);

  now = (new Date(now.getTime() - data.getTime())).getTime()
  horas = Math.floor(now/3600000)
  min = Math.floor((now - horas*3600000)/60000)
	return horas+":"+("0"+min).substr(-2);
}

export function appendScript(url, callback=()=>{}){
  let script  = document.createElement('script')
  script.charset  = "utf-8" 
  script.src  = url
  script.onload = callback
  document.querySelector('body').appendChild(script)
}

export function appendMetaTag(name, content){
  let meta    = document.createElement('meta')
  meta.name   = name
  meta.content= content
  document.querySelector('head').appendChild(meta)
}

export function appendLinkTag(rel, href){
  let link    = document.createElement('link')
  link.rel    = rel
  link.href   = href
  document.querySelector('head').appendChild(link)
}

export function swalTimerDialog(title="", html="", icon="error", callback=()=>{}, timer=2000){
  Swal.fire({
      html,
      title,
      icon,
      timer,
      showConfirmButton: false
  }).then(()=>{ callback() })
}

export function swalConfirmDialog(title="", html="", icon="error", callback=()=>{}, confirmButtonText="CONFIRMAR", cancelButtonText="CANCELAR"){
  Swal.fire({
      html,
      title,
      icon,      
      confirmButtonText,
      cancelButtonText,
      showConfirmButton: true,
      showCancelButton: true
  }).then((result)=>{ callback(result) })
}

export function isValidCPF(CPF) { const strCPF = CPF.replace(/[^\d]+/g, ''); let Soma = 0, Resto, i; if (strCPF === "00000000000") return false; for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i); Resto = (Soma * 10) % 11; if ((Resto === 10) || (Resto === 11)) Resto = 0; if (Resto !== parseInt(strCPF.substring(9, 10)) ) return false; Soma = 0; for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i); Resto = (Soma * 10) % 11; if ((Resto === 10) || (Resto === 11)) Resto = 0; if (Resto !== parseInt(strCPF.substring(10, 11) ) ) return false; return true; }

export function isValidCNPJ(c) {
  let cnpj = c.replace(/[^\d]+/g, '');
  if (cnpj === '') return false;
  if (cnpj.length !== 14)
      return false;
    
  // Elimina CNPJs invalidos conhecidos
  if (cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999")
      return false;

  // Valida DVs
  let tamanho = cnpj.length - 2,
  numeros = cnpj.substring(0, tamanho),
  digitos = cnpj.substring(tamanho),
  soma = 0,
  pos = tamanho - 7,
  i, resultado;
  for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  
  if (resultado !== digitos.charAt(0)*1)
      return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  
  if (resultado !== digitos.charAt(1)*1)
      return false;
  
  return true;
}

export async function getEndereco(cep){
		Axios.defaults.withCredentials = false
		let v		= onlyNumbers(cep),
			resp	= await Axios.get( window.location.protocol+'//viacep.com.br/ws/' + v +'/json/'),
			endereco= {}
		if(resp.status === 200){
			const {data} = resp
			endereco = {
				cep         :   data.cep,
				logradouro  :   data.logradouro,
				bairro      :   data.bairro,
				cidade      :   data.localidade,
				estado      :   data.uf
			}
		}
		Axios.defaults.withCredentials = true
		return endereco
}

export const ID = txt => document.getElementById(txt)  

export const validPhone = (fone) => {
	var f=fone.replace(/\(|\)|\s|-/g,''), re =/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/; return re.test(f) && f.length>12 }
 
export const formatDateTime= (data) => {
  const dt = new Date(data)
  return ("0"+dt.getDate()).substr(-2)+"/"+mesesAbrev[dt.getMonth()]+"/"+dt.getFullYear()+ " às "+("0"+dt.getHours()).substr(-2)+":"+("0"+dt.getMinutes()).substr(-2)
}
export const isValidDateTxt = (data) => {
  const dt = new Date(data.substr(-4)+"-"+data.substr(2,2)+"-"+data.substr(0,2)+ " 00:00:00")
  
  return dt instanceof Date && !isNaN(dt.valueOf())
  
}
export const isValidDate = (data) => {
  const dt = new Date(data)
  
  return dt instanceof Date && !isNaN(dt.valueOf())
  
}

export const isValidAnoFabMod = (anoMF) => {
  const ano = (new Date()).getFullYear()
  
  return anoMF*1>(ano-15) && anoMF*1<(ano+2) 
}

export const  isMobile = function() {var check = false;(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);return check;}

export const onlyNumbers = (txt) => txt.replace(/(?![0-9])./g,"")

export function isValidPhone(fone){ 
  var f=fone.replace(/[^0-9]/gm,''), re =/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/; return re.test(f) && f.length>9
}

export	function isValidEmail(email){
  const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|club|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/i;
  return re.test(email);
}

export const getNumberFormat = (value) => (<NumberFormat value={value} displayType="text" decimalSeparator="," thousandSeparator="." decimalScale="2" fixedDecimalScale={true}/>)

export const getNumberFormatTextMask = (value, mask) => (<NumberFormat value={value} displayType="text" format={mask} />)

export const setSelStock = (id, list, qtde) => {
    let    stock = list.filter(i => i._id!==id && i.foto.liberada),
           total = stock.length,
        selStock = [];
    //if(id & id.toString().length)
    //    stock = list.filter(i => i._id!==id && i.foto.liberada)
    if(total>qtde){
        for(let i=0; i<qtde; i++){
            let idx = Math.ceil(total*Math.random())
            if(stock[idx]){
                selStock.push(stock[idx])
                stock.splice(idx, 1)
                total--
            }else i--
        }
    }else selStock = stock
    return selStock
}

export const offsetElement = (el) => {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export const scrollTo = (pos=0) => { 
  try{
    window.scrollTo({top:pos, behavior: 'smooth'}) 
  }catch(e){
    window.scrollTo(0, pos)
  }
}

export const scrollToElement = (id,ajuste=0) => { 
    try{
      scrollTo(Math.ceil(offsetElement(document.getElementById(id)).top - ajuste)) 
    }catch(e){ }
}

export const getDescSplit = (txt) => {
    let desc = txt.trim().replace(/<\//g,'<').replace(/<v>/gi,"&nbsp;")
    return desc.split("&nbsp;")
}

export const putBR = (txt) => {
    let   desc = txt.split(/\n/g),
        result = desc.map((d, i) => <span key={i}>{d}<br/></span>);

    return <>{result}</>
}

export function NumberFormatCustom(props) {
    const { inputRef, onChange, name, id,...other } = props,
            obj = JSON.parse(name);
            
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            currentTarget: {
              id,
              value: values.value,
            },
          });
        }}

        format={obj.mask ? obj.mask : null}
        displayType={obj.displayType}
        prefix={obj.prefix}
        suffix={obj.suffix}
        decimalSeparator=","
        thousandSeparator="."
        //isNumericString
      />
    );
  }
  
  NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  };